import styled from 'styled-components';

export const StyledErrorPageContainer = styled.div`
    position: absolute;
    z-index: 4;
    height: 100vh;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledLogo = styled.div`
    padding-top: 20px;
`;

export const StyledContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const StyledErrorPageText = styled.div`
    font-size: 14px;
    margin-top: 20px;
    padding: 0 25px;
    text-align: center;
`;

export const StyledTryAgainButton = styled.button`
    cursor: pointer;
    background-color: #066fac;
    color: #fff;
    width: 276px;
    height: 32px;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 18px;
    font-size: 14px;
    border: none;
`;

export const StyledSignOutButton = styled.button`
    cursor: pointer;
    color: #066fac;
    font-size: 14px;
    text-decoration: underline;
    padding-bottom: 14px;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    border: none;
    background: transparent;
`;

export const StyledLoading = styled.div`
    position: absolute;
    z-index: 5;
    height: 100vh;
    width: 100%;
    background-color: #fff;
    opacity: 0.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
